/**
 * @name   {removeNonASCII} - Remove non-printable ASCII chars
 * @param  {String} str
 * @return {String}
 *
 * ASCII: http://en.wikipedia.org/wiki/ASCII#ASCII_printable_characters
 */
var removeNonASCII = function removeNonASCII(str) {
  return str.replace(/[^\x20-\x7F]/g, '');
};

export default removeNonASCII;